// extracted by mini-css-extract-plugin
module.exports = {"message":"tYk2NtbNm4XQF_NI46lQL"};